var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 54"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 80",
    transform: "translate(-.2 -.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#0dd674",
    "data-name": "Ret\\xE2ngulo 32",
    rx: 27,
    transform: "translate(.2 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.3 9.9a17.1 17.1 0 0 0-14.9 25.7l-2.3 8.6 9-2.1a17.1 17.1 0 0 0 8.2 2 17.1 17.1 0 1 0 0-34.2Zm0 3.4a13.7 13.7 0 1 1-6.6 25.8l-1.1-.7-1.3.3-3.4.8.8-3 .4-1.4-.7-1.2a13.7 13.7 0 0 1 11.9-20.6Zm-6 5.8a1.6 1.6 0 0 0-1.2.5 4.8 4.8 0 0 0-1.5 3.6 8.3 8.3 0 0 0 1.7 4.4c.2.3 3 4.8 7.4 6.5 3.6 1.4 4.3 1.1 5 1a4.3 4.3 0 0 0 3-2 3.6 3.6 0 0 0 .2-2c0-.2-.4-.3-.8-.5l-3-1.4c-.4-.2-.6-.2-.9.2L31 31.1c-.3.3-.5.3-1 .1a11.8 11.8 0 0 1-3.4-2.1 13 13 0 0 1-2.4-3c-.2-.4 0-.6.2-.9l.6-.7a3 3 0 0 0 .5-.7.8.8 0 0 0 0-.8c-.2-.2-1-2.3-1.4-3.2-.3-.7-.7-.7-1-.7h-.8Z"
  }))));
};
export default SvgWhatsapp;